import React from "react";
import { graphql } from "gatsby";

import SEO from "../components/SEO/SEO";
import DynamicZone from "../components/DynamicZone/DynamicZone";

export default function Home({
  data: {
    strapi: { executive },
  },
  location,
}) {
  return (
    <>
      <SEO
        title="Executive Coaching"
        description={executive.seoDescription}
        pathname={location.pathname}
        cssClass="t-executive"
      />

      <div className="content-page">
        {executive && executive.content && (
          <DynamicZone components={executive.content} />
        )}
      </div>
    </>
  );
}

export const query = graphql`
  query executivePageQuery {
    strapi {
      executive {
        seoDescription
        content {
          __typename
          ... on StrapiQuery_ComponentExecutiveNetwork {
            id
            title
            items {
              id
              name
              role
              image {
                url
                imageFile {
                  childImageSharp {
                    fluid(maxWidth: 400) {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
            }
          }
          ... on StrapiQuery_ComponentExecutiveIconList {
            id
            title
            icons {
              id
              icon
              name
            }
          }
          ... on StrapiQuery_ComponentExecutiveSchedule {
            id
            title
            items {
              id
              name
              date
            }
          }
          ... on StrapiQuery_ComponentCommonQuote {
            id
            author
            quote
          }
          ... on StrapiQuery_ComponentCommonStatement {
            id
            statement
            url
            urlText
          }
          ... on StrapiQuery_ComponentExecutiveVideo {
            id
            videoNumber
            videoTitle
          }
          ... on StrapiQuery_ComponentCommonTestimonial {
            id
            introduction
            testimonial {
              slug
              thumbnail {
                url
                imageFile {
                  childImageSharp {
                    fluid(maxWidth: 400) {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
            }
          }
          ... on StrapiQuery_ComponentCommonContactForm {
            id
            message
          }
        }
      }
    }
  }
`;
